/* eslint-disable angular/no-directive-replace */
/* eslint-disable angular/function-type */
(function () {
    'use strict';

    // Used as a hack for field validation when using directives not hooked
    // into the angular form
    angular.module('app').directive('fodbzTextRequiredHidden', [function () {
        return {
            require: '^ngModel',
            transclude: true,
            replace: true,
            scope: {
                fodbzModel: '=',
                fodbzFieldConst: '@',
                fodbzField: '@',
                fodbzInfo: '@',
                fodbzInfoTitle: '@',
                fodbzSizeText: '@',
                fodbzType: '@',
                fodbzInit: '@',
                fodbzValid: '@'
            },
            controller: ['$scope', function ($scope) {
                $scope.fodbzType = angular.isDefined($scope.fodbzType) ? $scope.fodbzType : 'text';
                if ($scope.fodbzType === 'text') {
                    $scope.fodbzInit = angular.isDefined($scope.fodbzInit) ? $scope.fodbzInit : '';
                }
                else if ($scope.fodbzType === 'url') {
                    $scope.fodbzInit = angular.isDefined($scope.fodbzInit) ? $scope.fodbzInit : 'https://';
                }
                else if ($scope.fodbzType === 'number') {
                    $scope.fodbzInit = angular.isDefined($scope.fodbzInit) ? $scope.fodbzInit : '0';
                }
            }],
            template: '<input aria-describedby="{{fodbzFieldConst}}{{fodbzValid}}" \
                            class="form-control {{fodbzSizeText}}" \
                            id="{{fodbzFieldConst}}" \
                            name="{{fodbzFieldConst}}" \
                            ng-model="fodbzModel" \
                            ng-model-options="{ updateOn: \'default blur\', debounce: { default: 500, blur: 0 } }"\
                            ng-required="true" \
                            placeholder="{{fodbzInit}}" \
                            type="{{fodbzType}}" value="" required="required" ng-show="false">'
        };
    }]);

    angular.module('app').directive('fodbzMultilineRequired', [function () {
        return {
            transclude: true,
            replace: true,
            scope: {
                fodbzModel: '=',
                fodbzField: '@',
                fodbzFieldConst: '@',
                fodbzInfoTitle: '@',
                fodbzInfo: '@',
                fodbzResource: '@',
                fodbzRowCount: '@',
                fodbzMaxlength: '@',
                fodbzDisabled: '=?'
            },
            template: `<textarea
                            aria-describedby="{{fodbzFieldConst}}Error"
                            class="form-control"
                            id="{{fodbzFieldConst}}"
                            name="{{fodbzFieldConst}}"
                            maxlength="{{fodbzMaxlength}}"
                            ng-model="fodbzModel"
                            rows="{{fodbzRowCount}}"
                            ng-required="true"
                            type="text" value="" required="required" style="resize: vertical; max-height: 35vh; min-height: 13vh;"
                            ng-disabled="{{fodbzDisabled}}">
                       </textarea>`,
        };
    }]);
})();